import type { PrimaryControlsStripBackAppShellPlacement } from "@-/dev.improve.haniverse.contexts.primary-controls-strip.back";
import { usePrimaryControlsStripBackResolution } from "#use-primary-controls-strip-back-resolution";

/**
 * Whether a back control will render in the given lane.
 *
 * This is a thin read of `usePrimaryControlsStripBackResolution` — the same predicate `usePrimaryControlsStripBackGate`
 * uses — so a caller reserving space for the control can never disagree with the lane's owner
 * about whether the control exists. Callers:
 *
 * - `AppLayoutContent` reserves horizontal toolbar space for the shell's leading chevron.
 * - `PrimaryControlsStrip` renders a balancing spacer when the back slot is empty but the right column shows
 *   the expansion chevron, keeping the centered title screen-centered.
 *
 * Always false on web (no native back control).
 */
export function usePrimaryControlsStripHasBackControl({
  appShellPlacement,
}: {
  appShellPlacement?: PrimaryControlsStripBackAppShellPlacement;
} = {}): boolean {
  return usePrimaryControlsStripBackResolution({ appShellPlacement }).isVisible;
}
